import type { AxiosRequestConfig } from "axios";
import type { IPaginated, IRepositoryOptions } from "@/types/common";
import type { ILoanProcessor } from "@/types/users-loan-processors";
import { BaseRepository } from "../BaseRepository";
import type { LoanProcessorsService } from "./service";
import type {
  IDeleteLoanProcessorRequest,
  IGetLoanProcessorProfileByUserIdRequest,
  IGetLoanProcessorsRequest,
  IUpdateLoanProcessorRequest,
} from "./types";

export class LoanProcessorsRepository extends BaseRepository {
  constructor(
    private readonly service: LoanProcessorsService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(
    p: IGetLoanProcessorsRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPaginated<ILoanProcessor>> {
    const response = await this.handleRequest(
      this.service.listLoanProcessors,
      p,
      c,
    );
    return response.data;
  }

  async deleteLoanProcessor(
    p: IDeleteLoanProcessorRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    await this.handleRequest(this.service.deleteLoanProcessor, p, c);
  }

  async getProfileByUserId(
    p: IGetLoanProcessorProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): Promise<ILoanProcessor> {
    const response = await this.handleRequest(
      this.service.getProfileByUserId,
      p,
      c,
    );
    return response.data;
  }

  async updateProfile(
    p: IUpdateLoanProcessorRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    await this.handleRequest(this.service.updateProfile, p, c);
  }
}
